module.exports = __webpack_public_path__ + "static/img/jian.3d01bdf8.png";